export default "__VITE_ASSET__101ceZkN__"